import { createFileRoute, notFound } from "@tanstack/react-router";
import { getPage } from "@/content/pages";
import { MarkdownPage } from "@/components/MarkdownPage";
import ServiceSeoImage from "@/assets/service-seo.jpg";
import { breadcrumbScript, ORGANIZATION_ID, SITE_URL } from "@/lib/seo";

const PAGE_KEY = "/seo";

export const Route = createFileRoute("/seo/")({
  loader: () => {
    const page = getPage(PAGE_KEY);
    if (!page) throw notFound();
    return page;
  },
  head: ({ loaderData }) => {
    return {
      meta: loaderData
        ? [
            { title: loaderData.title },
            { name: "description", content: loaderData.description },
            { property: "og:title", content: loaderData.title },
            { property: "og:description", content: loaderData.description },
            { property: "og:url", content: `${SITE_URL}${PAGE_KEY}` },
          ]
        : [],
      links: [{ rel: "canonical", href: `${SITE_URL}${PAGE_KEY}` }],
      scripts: loaderData
        ? [
            breadcrumbScript([
              { name: "Home", url: `${SITE_URL}/` },
              { name: "SEO", url: `${SITE_URL}${PAGE_KEY}` },
            ]),
            {
              type: "application/ld+json",
              children: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Service",
                name: "Freelance SEO Consultant UK",
                description:
                  "Hands-on technical, content, ecommerce, local and national SEO consultancy for UK businesses.",
                serviceType: [
                  "Technical SEO",
                  "Content SEO",
                  "Ecommerce SEO",
                  "Local SEO",
                  "National SEO",
                ],
                provider: { "@id": ORGANIZATION_ID },
                areaServed: ["Barnsley", "South Yorkshire", "West Yorkshire", "United Kingdom"],
              }),
            },
          ]
        : [],
    };
  },
  notFoundComponent: () => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-4xl">Page not found</h1>
    </div>
  ),
  component: SeoIndexPage,
});

function SeoIndexPage() {
  const page = Route.useLoaderData();

  return (
    <MarkdownPage
      body={page.body}
      pageContext={page.title}
      heroImage={{
        src: ServiceSeoImage,
        alt: "SEO strategy workspace with charts, magnifier and notebook",
      }}
      relatedSlugs={[
        "seo-strategy-for-small-businesses-building-consistent-enquiries-in-2026",
        "common-seo-mistakes-that-hold-small-businesses-back",
        "how-seo-builds-momentum-over-time-for-small-businesses",
      ]}
    />
  );
}
